export default "__VITE_ASSET__99ea4c19__"